import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  colorLandingBrandSoft,
  colorLandingBrandStrong,
  colorLandingInk,
  colorLandingLine,
  colorLandingMuted,
  colorLandingText,
  radiusLandingControl,
} from "src/design/tokens";

// Illustrative guests for the product mock.
const BOOKINGS = [
  { initials: "SB", name: "Sofia Bennani", covers: 4, time: "20:30" },
  { initials: "YM", name: "Younes Mansouri", covers: 2, time: "21:00" },
];

/** "Today's reservations" card inside the dashboard mock. */
export const DashboardBookingsCard = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        border: `1px solid ${colorLandingLine}`,
        borderRadius: radiusLandingControl,
        overflow: "hidden",
        mb: 1.75,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          px: 1.75,
          py: 1.5,
          borderBottom: `1px solid ${colorLandingLine}`,
        }}
      >
        <Box>
          <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: colorLandingInk }}>
            {t("landingPage.ecosystem.dashboard.bookingsToday")}
          </Typography>
          <Typography sx={{ fontSize: 10, color: colorLandingMuted, mt: 0.25 }}>
            {t("landingPage.ecosystem.dashboard.bookingsTodaySub")}
          </Typography>
        </Box>
        <Typography
          sx={{ fontSize: 11, fontWeight: 600, color: colorLandingBrandStrong }}
        >
          {t("landingPage.ecosystem.dashboard.seeAll")}
        </Typography>
      </Box>

      {BOOKINGS.map((booking, index) => (
        <Box
          key={booking.initials}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.25,
            px: 1.75,
            py: 1.125,
            borderBottom:
              index === BOOKINGS.length - 1
                ? "none"
                : `1px solid ${colorLandingLine}`,
          }}
        >
          <Box
            sx={{
              width: 26,
              height: 26,
              borderRadius: "50%",
              backgroundColor: colorLandingBrandSoft,
              color: colorLandingBrandStrong,
              display: "grid",
              placeItems: "center",
              fontWeight: 700,
              fontSize: 10,
              flexShrink: 0,
            }}
          >
            {booking.initials}
          </Box>
          <Typography sx={{ fontSize: 12, fontWeight: 600, color: colorLandingText }}>
            {booking.name}
            <Box
              component="span"
              sx={{ color: colorLandingMuted, fontWeight: 400, fontSize: 11 }}
            >
              {` · ${booking.covers} ${t(
                "landingPage.ecosystem.dashboard.covers"
              ).toLowerCase()}`}
            </Box>
          </Typography>
          <Box
            sx={{
              ml: "auto",
              fontSize: 9.5,
              fontWeight: 600,
              px: 1,
              py: 0.375,
              borderRadius: 999,
              backgroundColor: colorLandingBrandSoft,
              color: colorLandingBrandStrong,
              whiteSpace: "nowrap",
            }}
          >
            {t("landingPage.ecosystem.dashboard.confirmed")}
          </Box>
          <Typography
            sx={{
              fontSize: 11.5,
              fontWeight: 700,
              color: colorLandingText,
              minWidth: 36,
              textAlign: "right",
            }}
          >
            {booking.time}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
